import apiClientService from "./ApiClientService";

/**
 * GET /booking-monitor/statuses — starea programării elevilor urmăriți
 * (doar admin / manager).
 * Răspuns: { enabled, since, statuses: [{ userId, status, stage, day?, daysLeft? }] }
 *  - status: PENDING (galben) | BOOKED (verde) | OVERDUE (roșu)
 *  - stage: FIRST_BOOKING (încă nu s-a programat) | NEXT_PACKAGE (se termină pachetul de 15) | null
 */
export async function getBookingStatuses() {
   const res = await apiClientService.get("/booking-monitor/statuses");
   if (!res.ok) throw new Error(`HTTP ${res.status}`);
   return res.json();
}
